import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    parentId = '',
    name,
    summary,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.industry.save, {
        id,
        parentId,
        name,
        summary,
    }, options);
    if (error) return { error, status };
    return content || {};
};
